import React, { useEffect } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import TagManager from 'react-gtm-module';


const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
const tagManagerArgs = {
  gtmId: 'GTM-KVCH49NR',
};

TagManager.initialize(tagManagerArgs);
  useEffect(() => {
    // Get the eventId from the URL
    const urlParams = new URLSearchParams(location.search);
    const eventId = urlParams.get('eventId') || urlParams.get('eventid');;
    if (eventId) {
      localStorage.setItem('eventId', eventId);

      // Redirect to the login page
      const isEntryPoint = location.pathname === "/" || location.pathname === "/auth" || location.pathname === "/auth/";
      if (isEntryPoint) {
        if(JSON.parse(localStorage.getItem('isVerifiedUser'))) {
          navigate("/auth/events");
        } else {
          navigate("/auth/sign-in");

        }
      }
    }
  }, [location]);
  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="admin/*" element={<AdminLayout />} />
      <Route path="/" element={<Navigate to="/auth" replace />} />
    </Routes>
  );
};

export default App;